export default {
  grande_sao_paulo: [
    {
      id: 1,
      label: 'Interlagos',
      code: 'interlagos'
    },
    {
      id: 10,
      label: 'São Caetano',
      code: 's_caetano'
    },
    {
      id: 5,
      label: 'Raposo Tavares',
      code: 'raposo_tav'
    },
    {
      id: 12,
      label: 'Morumbi',
      code: 'morumbi'
    },
    {
      id: 16,
      label: 'Ricardo Jafet',
      code: 'rjafet'
    },
    {
      id: 24,
      label: 'Lar Center',
      code: 'centernort'
    },
    {
      id: 42,
      label: 'Jaguaré',
      code: 'jaguare'
    },
    {
      id: 45,
      label: 'São Bernardo',
      code: 's_bernardo_campo'
    },
    {
      id: 46,
      label: 'Tamboré',
      code: 'tambore'
    },
    {
      id: 41,
      label: 'Anália Franco',
      code: 'analia_franco'
    },
    {
      id: 58,
      label: 'Marginal Tietê',
      code: 'tiete_sap'
    }
  ],
  rio_de_janeiro: [
    {
      id: 11,
      label: 'Rio Barra',
      code: 'rio_barra'
    },
    {
      id: 7,
      label: 'Rio Norte - Del Castilho',
      code: 'rio_norte'
    },
    {
      id: 17,
      label: 'Bangu',
      code: 'bangu'
    },
    {
      id: 21,
      label: 'Niterói',
      code: 'niteroi'
    },
    {
      id: 26,
      label: 'Jacarepaguá',
      code: 'jacarepagu'
    }
  ],
  campinas: [
    {
      id: 3,
      label: 'Campinas D.pedro',
      code: 'campinas'
    },
    {
      id: 22,
      label: 'Anhanguera',
      code: 'anhanguera'
    }
  ],
  grande_porto_alegre: [
    {
      id: 19,
      label: 'Porto Alegre',
      code: 'poa'
    },
    {
      id: 32,
      label: 'São Leopoldo',
      code: 's_leopoldo'
    }
  ],
  rib_preto: [
    {
      id: 2,
      label: 'Ribeirão Preto',
      code: 'rib_preto'
    }
  ],
  sorocaba: [
    {
      id: 27,
      label: 'Sorocaba',
      code: 'sorocaba'
    }
  ],
  curitiba: [
    {
      id: 9,
      label: 'Curitiba (Sul)',
      code: 'curitiba'
    },
    {
      id: 35,
      label: 'Curitiba Atuba',
      code: 'curitibatu'
    }
  ],
  uberlandia: [
    {
      id: 29,
      label: 'Uberlândia',
      code: 'uberlandia'
    }
  ],
  belo_horizonte: [
    {
      id: 4,
      label: 'Contagem',
      code: 'contagem'
    },
    {
      id: 20,
      label: 'BH-Sul',
      code: 'bh_sul'
    },
    {
      id: 36,
      label: 'BH-Norte',
      code: 'bh_norte'
    }
  ],
  brasilia: [
    {
      id: 13,
      label: 'Brasília Sul',
      code: 'brasilia'
    },
    {
      id: 23,
      label: 'Taguatinga',
      code: 'taguatinga'
    },
    {
      id: 28,
      label: 'Brasília Norte',
      code: 'brasilia_n'
    }
  ],
  vale_do_paraiba: [
    {
      id: 15,
      label: 'São José Campos',
      code: 'sjcampos'
    },
    {
      id: 55,
      label: 'Taubaté',
      code: 'taubate'
    }
  ],
  sao_jose_do_rio_preto: [
    {
      id: 34,
      label: 'São José Do Rio Preto',
      code: 'sj_r_preto'
    }
  ],
  goiania: [
    {
      id: 18,
      label: 'Goiânia',
      code: 'goiania'
    }
  ],
  londrina: [
    {
      id: 33,
      label: 'Londrina',
      code: 'londrina'
    }
  ],
  ceara: [
    {
      id: 38,
      label: 'Fortaleza',
      code: 'fortaleza'
    }
  ],
  mato_grosso_do_sul: [
    {
      id: 44,
      label: 'Campo Grande',
      code: 'campo_grande'
    }
  ],
  mato_grosso: [
    {
      id: 44,
      label: 'Campo Grande',
      code: 'campo_grande'
    }
  ],
  alagoas: [
    {
      id: 50,
      label: 'Maceió',
      code: 'maceio'
    }
  ],
  rio_grande_do_norte: [
    {
      id: 51,
      label: 'Natal',
      code: 'natal'
    }
  ],
  santa_catarina: [
    {
      id: 39,
      label: 'São José',
      code: 'sj_floripa'
    }
  ]
}
